export const SECURE_MESSAGE_ELIGIBLE_SCOPES = ['cipxaccountuser'];
